import { render, staticRenderFns } from "./veStuGraduationAuditConfigShow.vue?vue&type=template&id=980e27f6&scoped=true"
import script from "./veStuGraduationAuditConfigShow.vue?vue&type=script&lang=js"
export * from "./veStuGraduationAuditConfigShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980e27f6",
  null
  
)

export default component.exports